
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipperguide",
      function () {
        return require("private-next-pages/shipperguide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipperguide"])
      });
    }
  